<style scoped>
.leave-notification {
  width: 100%;
  height: 40px;
  position: relative;
  top: -24px;
  background-color: #d06f1a;
  border-radius: 0px 0px 10px 10px;
  color: #ffff;
  padding: 3px;
}
</style>
<template>
  <v-container v-if="!edit" class="my-3">
    <div v-if="isLeaveStock" class="leave-notification">
      <span id="msg-span"></span>
    </div>
    <v-data-table
      :headers="columns"
      :items="items"
      :items-per-page="5"
      :loading="loading"
      class="elevation-1"
      dense
      item-key="id"
    >
      <template v-slot:top>
        <v-toolbar color="white" flat>
          <v-toolbar-title>
            {{ title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialog"
            persistent
            max-width="1200"
            v-if="isLicense"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" small>
                {{ isGoodStanding ? "Add GoodStanding" : "Add License" }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">Add {{ isGoodStanding?'Letter':'License' }} From eHPL</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="4" sm="4" md="4">
                      <v-text-field
                        v-model="searchLicense"
                        append-icon="mdi-magnify"
                        label="Search Using License Number"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" md="2" class="mt-4">
                      <v-btn
                        :loading="loadingSearch"
                        class="primary"
                        @click="searchLicenses()"
                      >
                        Search
                        <template v-slot:loader>
                          <span class="custom-loader">
                            <v-icon light>mdi-cached</v-icon>
                          </span>
                        </template>
                      </v-btn>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-card
                        :loading="loadingSearch"
                        class="my-4"
                        max-width="600"
                      >
                        <template slot="progress">
                          <v-progress-linear
                            color="primary"
                            height="10"
                            indeterminate
                          ></v-progress-linear>
                        </template>
                        <v-card-title>License Information</v-card-title>

                        <v-card-text>
                          <v-row align="center" class="mx-0">
                            {{ searchLicense }}
                          </v-row>
                        </v-card-text>

                        <v-divider class="mx-4"></v-divider>

                        <v-list two-line>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary"> mdi-account-box </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold"
                                >Employee Name
                              </v-list-item-title>

                              <v-list-item-title>
                                {{
                                  licenseData
                                    ? (licenseData.profile
                                        ? licenseData.profile.name
                                        : "") +
                                      " " +
                                      (licenseData.profile
                                        ? licenseData.profile.fatherName
                                        : "") +
                                      " " +
                                      (licenseData.profile
                                        ? licenseData.profile.grandFatherName
                                        : "")
                                    : ""
                                }}</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider inset></v-divider>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary"> mdi-check </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">{{
                                isGoodStanding ? "Is Letter Valid" : "Certified"
                              }}</v-list-item-title>
                              <v-list-item-subtitle
                                >{{
                                  licenseData
                                    ? licenseData.certified
                                      ? "Yes"
                                      : "No"
                                    : ""
                                }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-divider inset></v-divider>

                          <v-list-item v-if="licenseData.certifiedDate">
                            <v-list-item-icon>
                              <v-icon color="primary"
                                >mdi-calendar-check</v-icon
                              >
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">{{
                                isGoodStanding
                                  ? "Letter Generated Date"
                                  : "Certified Date"
                              }}</v-list-item-title>
                              <v-list-item-subtitle>{{
                                licenseData && licenseData.certifiedDate
                                  ? licenseData.certifiedDate.slice(0, 10)
                                  : ""
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item v-if="licenseData.licenseExpirationDate">
                            <v-list-item-icon>
                              <v-icon color="primary"
                                >mdi-calendar-clock</v-icon
                              >
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold"
                                >Expiration Date</v-list-item-title
                              >
                              <v-list-item-subtitle>{{
                                licenseData && licenseData.licenseExpirationDate
                                  ? licenseData.licenseExpirationDate.slice(
                                      0,
                                      10
                                    )
                                  : ""
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-divider inset></v-divider>

                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary">
                                mdi-card-account-details
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content v-if="!isGoodStanding">
                              <v-list-item-title class="font-weight-bold"
                                >License Professions</v-list-item-title
                              >
                              <v-list-item-subtitle
                                v-for="profession in licenseData.educations"
                                :key="profession.professionType.id"
                              >
                                <span>
                                  {{
                                    profession&&profession.prefix ? profession.prefix : "" + "-"
                                  }}</span
                                >
                                {{
                                  profession && profession.professionType
                                    ? profession.professionType.name
                                    : 
                                    profession && profession.otherProfessionType
                                    ? profession.otherProfessionType
                                    : ''
                                }}</v-list-item-subtitle
                              >
                            </v-list-item-content>
                            <v-list-item-content v-if="isGoodStanding">
                              <v-list-item-title class="font-weight-bold"
                                >License Professions</v-list-item-title
                              >
                              <v-list-item-subtitle
                                v-for="profession in licenseData.GSProfessionals"
                                :key="profession.professionalTypes.name"
                              >
                                <span>
                                  {{
                                    profession ? profession.prefix : "" + "-"
                                  }}</span
                                >
                                {{
                                  profession && profession.professionalTypes
                                    ? profession.professionalTypes.name
                                    : ""
                                }}</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="warning" text @click="dialog = false">
                  Close
                </v-btn>
                <v-btn class="primary"  :disabled="saveLicenseButton" text @click="saveLicense()">
                  Save
                </v-btn>
              </v-card-actions>

              <v-snackbar v-model="snackbar" background-color="warning" text>
                {{ message }}

                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                  >
                    Close
                  </v-btn>
                </template>
              </v-snackbar>
            </v-card>
          </v-dialog>
          <div v-for="action in topActions" :key="action.text">
            <v-btn
              v-if="
                !(isSelfService && disabled.includes(action.text)) && !isLicense
              "
              :color="action.class"
              :to="setupLink(action.link, {})"
              small
            >
              {{ action.text }}
            </v-btn>
          </div>
        </v-toolbar>
      </template>
      <template v-slot:item._action="{ item }">
        <div v-for="action in item.actions" :key="action.text">
          <v-btn
            v-if="!(isSelfService && disabled.includes(action.text))"
            :color="action.class"
            :to="setupLink(action.link, item)"
            rounded
            small
          >
            {{ action.text }}
          </v-btn>
        </div>
        <div v-for="action in item.deleteButton" :key="action.text">
          <v-btn
            v-if="!isSelfService"
            :disabled="action.disabled"
            color="error"
            rounded
            small
            v-on:click="deleteRecord(item)"
          >
            {{ action.text }}
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ethiopic from "ethiopic-calendar";
import axios from "axios";
const isObject = (obj) => {
  return !!obj && obj.constructor === Object;
};
export default {
  name: "ihris-secondary",
  props: [
    "title",
    "field",
    "profile",
    "slotProps",
    "link-id",
    "link-field",
    "search-field",
    "edit",
    "columns",
    "actions",
  ],
  data: function () {
    return {
      source: { data: {}, path: this.field },
      empty: true,
      items: [],
      loading: true,
      dialog: false,
      deleteLoading: false,
      topActions: [],
      isLeaveStock: false,
      visible: true,
      deleteDisabled: false,
      output: "",
      loadingSearch: false,
      searchLicense: "",
      snackbar: false,
      message: "",
      licenseData: {},
      isGoodStanding: false,
      isNewLicense: false,
      isRenewal: false,
      isLicense: false,
      saveLicenseButton:true,
      disabled: [
        "Add Leave Stock",
        "Add Performance Appraisal",
        "Add Salary Info",
        "Assign Permanent Job",
        "Assign Contract",
        "Renew",
        "View",
        "Delete",
        "Terminate Job",
        "Change Position",
      ],
      isSelfService: false,
    };
  },
  mounted: function () {
    this.setupData();
  },

  created: function () {
    if (
      this.profile ==
        "http://ihris.org/fhir/StructureDefinition/ihris-basic-license" ||
      this.profile ==
        "http://ihris.org/fhir/StructureDefinition/ihris-basic-license-renewal" ||
      this.profile ==
        "http://ihris.org/fhir/StructureDefinition/ihris-basic-good-standing"
    ) {
      this.isLicense = true;
    }

    this.getMonthlyLeaveDays();
  },
  methods: {
    deleteRecord: function (item) {
      this.deleteLoading = true;
      let result = `/fhir${item.resPath.split('fhir').pop()}`

      fetch(result).then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            //for leave stock record
            if (
              data.meta.profile[0] ===
              "http://ihris.org/fhir/StructureDefinition/ihris-basic-ethiopia-leave-stock"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url === "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url === "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url === "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code === "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url === "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url === "deletedStatus"
                ).valueCoding.display = "deleted";

                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            //for leave info record
            if (
              data.meta.profile[0] ===
              "http://ihris.org/fhir/StructureDefinition/ihris-basic-ethiopia-leave"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code == "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.display = "deleted";
                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            //for educational data record
            if (
              data.meta.profile[0] ==
              "http://ihris.org/fhir/StructureDefinition/ihris-basic-education-history"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code == "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.display = "deleted";
                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            //For assigned work
            if (
              data.meta.profile[0] ==
              "http://ihris.org/fhir/StructureDefinition/ihris-job-description"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code == "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.display = "deleted";
                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            //for performance data record
            if (
              data.meta.profile[0] ==
              "http://ihris.org/fhir/StructureDefinition/ihris-basic-performance"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code == "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.display = "deleted";
                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            //for work experiance
            if (
              data.meta.profile[0] ==
              "http://ihris.org/fhir/StructureDefinition/ihris-basic-employment-history"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code == "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.display = "deleted";
                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            //for emergency contact
            if (
              data.meta.profile[0] ==
              "http://ihris.org/fhir/StructureDefinition/ihris-basic-emergency"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code == "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.display = "deleted";
                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            //for collateral
            if (
              data.meta.profile[0] ==
              "http://ihris.org/fhir/StructureDefinition/ihris-basic-collateral"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code == "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.display = "deleted";
                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            //for discipline
            if (
              data.meta.profile[0] ==
              "http://ihris.org/fhir/StructureDefinition/ihris-basic-discipline"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code == "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.display = "deleted";
                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            //for salary
            if (
              data.meta.profile[0] ==
              "http://ihris.org/fhir/StructureDefinition/ihris-basic-salary"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code == "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.display = "deleted";
                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            //for award
            if (
              data.meta.profile[0] ==
              "http://ihris.org/fhir/StructureDefinition/ihris-basic-award"
            ) {
              if (
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ) &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code &&
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code == "active"
              ) {
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.code = "deleted";
                data.extension[1].extension.find(
                  (ext) => ext.url == "deletedStatus"
                ).valueCoding.display = "deleted";

                data.extension[1].extension.push({
                  url: "deletedBy",
                  valueString: this.$store.state.user.name,
                });
              }
            }

            this.deleteLoading = false;
            try {
              fetch(result, {
                method: "PUT",
                headers: {
                  "Content-Type": "application/fhir+json",
                },
                body: JSON.stringify(data),
              });

              setTimeout(this.setupData, 1000);
              this.deleteLoading = false;
            } catch (error) {
              console.log(error);
            }
          }).catch(err => {
            console.log("HEHEHEH",err)
          });
        }
      }).catch(err => {
        console.log(err)
      });
    },

    getMonthlyLeaveDays: async function () {
      this.isLeaveStock = this.profile.includes(
        "ihris-basic-ethiopia-leave-stock"
      );
      if (
        this.profile.includes(
          "http://ihris.org/fhir/StructureDefinition/ihris-job-description"
        )
      ) {
        let url = `/fhir/Basic?_profile=http://ihris.org/fhir/StructureDefinition/ihris-basic-ethiopia-leave-stock&practitioner=${this.linkId}`;
        let totalDate = 0;
        fetch(url).then((response) => {
          if (response.status === 200) {
            response.json().then((data) => {
              if (data.entry) {
                data.entry.map((item) => {
                  const leaveStockbundle = item.resource.extension.find(
                    (ext) =>
                      ext.url ==
                      "http://ihris.org/fhir/StructureDefinition/ihris-ethiopia-leave-stock"
                  );

                  if (leaveStockbundle) {
                    let stat;
                    let leaveType = leaveStockbundle.extension.find(
                      (ext) => ext.url == "leave-type"
                    ).valueCoding.code;
                    if (
                      leaveStockbundle.extension.find(
                        (ext) =>
                          ext.url == "deletedStatus" &&
                          leaveStockbundle.extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding &&
                          leaveStockbundle.extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code
                      )
                    ) {
                      stat = leaveStockbundle.extension.find(
                        (ext) => ext.url === "deletedStatus"
                      ).valueCoding.code;
                    }
                    if (leaveType === "annual" && stat != "deleted") {
                      totalDate += Number(
                        leaveStockbundle.extension.find(
                          (ext) => ext.url == "numDays"
                        ).valueString
                      );
                    }
                  }
                });
              }
              const p = document.createElement("p");
              p.textContent = `You have ${totalDate} annual leave days.`;
              document.getElementById("msg-span").appendChild(p);
            });
          }
        });
      }
    },
    setupData: function () {
      if (this.$store.state.user.role === "ihris-role-self") {
        this.isSelfService = true;
      }
      let url;
      //for searchfield in the form Location:organization with Location being the primary resource, then use _include to retrieve secondary resources
      if (this.searchField.split(":").length === 2) {
        let resource = this.searchField.split(":")[0];
        url =
          "fhir/" +
          resource +
          "?_id=" +
          this.linkId +
          "&_include=" +
          this.searchField;
      } else {
        url = "/fhir/" + this.field;
        let queryStr = [];
        if (this.profile) {
          queryStr.push("_profile=" + this.profile);
        }
        if (this.searchField) {
          queryStr.push(this.searchField + "=" + this.linkId);
        } else {
          queryStr.push(
            this.linkField.substring(this.linkField.indexOf(".") + 1) +
              "=" +
              this.linkId
          );
        }
        url += "?" + queryStr.join("&");
      }
      this.items = [];
      this.loading = true;
      this.addItems(url);
    },
    addItems: function (url) {
      fetch(url)
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then(async (data) => {
                if (data.entry && data.entry.length > 0) {
                  for (let entry of data.entry) {
                    if (
                      this.searchField.split(":").length === 2 &&
                      entry.resource.resourceType ===
                        this.searchField.split(":")[0]
                    ) {
                      continue;
                    }

                    let row = {
                      id: entry.resource.id,
                      resPath: entry.fullUrl,
                      res: entry.resource.extension[1],
                      deleteButton: [],
                    };

                    row.deleteButton.push({
                      class: "error",
                      data: entry.resource.extension[0].url,
                      row: true,
                      text: "Delete",
                      disabled: true,
                    });

                    for (let header of this.columns) {
                      if (header.value === "_action") continue;
                      try {
                        let content = this.$fhirpath.evaluate(
                          entry.resource,
                          header.value
                        );
                        if (header.text === "Year") {
                          content = this.convertGE(content[0]);
                        }
                        row[header.value] = await this.processContent(content);
                      } catch (err) {
                        console.log(err);
                      }
                    }

                    if (!row.actions) row.actions = [];
                    for (let action of this.actions) {
                      if (action.row) {
                        if (action.condition) {
                          let meets = this.$fhirpath.evaluate(
                            entry.resource,
                            action.condition
                          );
                          if (meets.every((meet) => meet)) {
                            row.actions.push(action);
                          }
                        } else {
                          row.actions.push(action);
                        }
                      } else {
                        if (action.condition) {
                          let meets = this.$fhirpath.evaluate(
                            entry.resource,
                            action.condition
                          );
                          if (action.hasOwnProperty("meets")) {
                            action.meets =
                              action.meets && meets.every((meet) => meet);
                          } else {
                            action.meets = meets.every((meet) => meet);
                          }
                        } else {
                          action.meets = true;
                        }
                      }
                    }

                    if (
                      entry.resource.meta.profile[0] ===
                      "http://ihris.org/fhir/StructureDefinition/ihris-job-description"
                    ) {
                      this.visible = false;
                    }
                    let role = this.$store.state.user.role;

                    //If user is not admin
                    if (role !== "ihris-role-admin") {
                      //  Discipline Contact
                      if (
                        entry.resource.meta.profile[0] ===
                        "http://ihris.org/fhir/StructureDefinition/ihris-basic-discipline"
                      ) {
                        if (
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url === "deletedStatus"
                          ) &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url === "deletedStatus"
                          ).valueCoding &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url === "deletedStatus"
                          ).valueCoding.code &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url === "deletedStatus"
                          ).valueCoding.code === "deleted"
                        ) {
                          continue;
                        }
                      }
                      // //Collateral Contact
                      if (
                        entry.resource.meta.profile[0] ==
                        "http://ihris.org/fhir/StructureDefinition/ihris-basic-collateral"
                      ) {
                        if (
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ) &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code == "deleted"
                        ) {
                          continue;
                        }
                      }

                      // //Emergency Contact
                      if (
                        entry.resource.meta.profile[0] ==
                        "http://ihris.org/fhir/StructureDefinition/ihris-basic-emergency"
                      ) {
                        if (
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ) &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code == "deleted"
                        ) {
                          continue;
                        }
                      }

                      // // For Salary

                      if (
                        entry.resource.meta.profile[0] ==
                        "http://ihris.org/fhir/StructureDefinition/ihris-basic-salary"
                      ) {
                        if (
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ) &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code == "deleted"
                        ) {
                          continue;
                        }
                      }

                      // //Leave Stock
                      if (
                        entry.resource.meta.profile[0] ==
                        "http://ihris.org/fhir/StructureDefinition/ihris-basic-ethiopia-leave-stock"
                      ) {
                        if (
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ) &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code == "deleted"
                        ) {
                          continue;
                        }
                      }
                      // //Leave Info

                      if (
                        entry.resource.meta.profile[0] ==
                        "http://ihris.org/fhir/StructureDefinition/ihris-basic-ethiopia-leave"
                      ) {
                        if (
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ) &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code == "deleted"
                        ) {
                          continue;
                        }
                      }
                      // //For Education
                      if (
                        entry.resource.meta.profile[0] ==
                        "http://ihris.org/fhir/StructureDefinition/ihris-basic-education-history"
                      ) {
                        if (
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ) &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code == "deleted"
                        ) {
                          continue;
                        }
                      }
                      // //Performance Appraisal
                      if (
                        entry.resource.meta.profile[0] ==
                        "http://ihris.org/fhir/StructureDefinition/ihris-basic-performance"
                      ) {
                        if (
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ) &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code == "deleted"
                        ) {
                          this.deleteDisabled = true;
                          continue;
                        }
                      }

                      // //Work Experiance
                      if (
                        entry.resource.meta.profile[0] ==
                        "http://ihris.org/fhir/StructureDefinition/ihris-basic-employment-history"
                      ) {
                        if (
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ) &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code == "deleted"
                        ) {
                          continue;
                        }
                      }

                      // //Award Experiance
                      if (
                        entry.resource.meta.profile[0] ==
                        "http://ihris.org/fhir/StructureDefinition/ihris-basic-award"
                      ) {
                        if (
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ) &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code &&
                          entry.resource.extension[1].extension.find(
                            (ext) => ext.url == "deletedStatus"
                          ).valueCoding.code == "deleted"
                        ) {
                          continue;
                        }
                      }
                    }
                    if (
                      entry.resource.meta.profile[0] !=
                      "http://ihris.org/fhir/StructureDefinition/ihris-job-description"
                    ) {
                      if (
                        entry.resource.extension[1].extension.find(
                          (ext) => ext.url == "deletedStatus"
                        ) &&
                        entry.resource.extension[1].extension.find(
                          (ext) => ext.url == "deletedStatus"
                        ).valueCoding &&
                        entry.resource.extension[1].extension.find(
                          (ext) => ext.url == "deletedStatus"
                        ).valueCoding.code &&
                        entry.resource.extension[1].extension.find(
                          (ext) => ext.url == "deletedStatus"
                        ).valueCoding.code != "deleted"
                      ) {
                        row.deleteButton[0].disabled = false;
                      }
                    }

                    this.items.push(row);
                  }
                } else {
                  for (let action of this.actions) {
                    if (!action.row) {
                      action.meets = action.emptyDisplay;
                    }
                  }
                }
                this.topActions = this.actions.filter(
                  (action) => !action.row && action.meets
                );

                if (data.link) {
                  let next = data.link.find((link) => link.relation === "next");
                  if (next) {
                    this.addItems(next.url);
                  } else {
                    this.loading = false;
                  }
                } else {
                  this.loading = false;
                }
              })
              .catch((err) => {
                this.loading = false;
                console.log("error", err);
              });
          } else {
            this.loading = false;
            console.log("Unable to fetch", url, response.status);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    processContent: async function (content) {
      if (Array.isArray(content)) {
        let output = await Promise.all(content.map(this.processContent));
        return output.join(" ");
      } else if (isObject(content)) {
        if (content.code && content.system) {
          return await this.$fhirutils.codeLookup(content.system, content.code);
        } else if (content.display) {
          return content.display;
        } else if (content.code) {
          return content.code;
        } else if (content.reference) {
          return await this.$fhirutils.resourceLookup(content.reference);
        } else {
          console.log("Unable to process content:", content);
          return "Unknown";
        }
      } else {
        return content;
      }
    },
    searchLicenses() {
      this.loadingSearch = true;
     
      fetch("/events/getLicenses/" + this.searchLicense.toUpperCase())
        .then((response) => {
          
          response
            .json()
            .then(async (data) => {
             if(data&&data.data){
              this.saveLicenseButton=false;
             }
              this.licenseData =
                data.data &&
                data.data.goodStanding != null &&
                data.data.goodStanding.certified == true
                  ? data.data.goodStanding
                  : data.data &&
                    data.data.newLicense != null &&
                    data.data.newLicense.certified == true
                  ? data.data.newLicense
                  : data.data &&
                    data.data.renewal != null &&
                    data.data.renewal.certified == true
                  ? data.data.renewal
                  : {};
              if (
                data.data &&
                data.data.goodStanding != null &&
                data.data.goodStanding.certified == true
              ) {
                this.isGoodStanding = true;
              } else {
                this.isGoodStanding = false;
              }

              if (
                data.data &&
                data.data.newLicense != null &&
                data.data.newLicense.certified == true
              ) {
                this.isNewLicense = true;
              } else {
                this.isNewLicense = false;
              }

              if (
                data.data &&
                data.data.renewal != null &&
                data.data.renewal.certified == true
              ) {
                this.isRenewal = true;
              } else {
                this.isRenewal = false;
              }
             
              if (
                data.data.newLicense == null &&
                data.data.renewal == null &&
                data.data.goodStanding == null
              ) {
                this.message =
                  "There is no license with the provided license number";
                this.snackbar = true;
                this.saveLicenseButton=true;
              }
              this.loadingSearch = false;
            })
            .catch((err) => {
              console.log(err);
              this.loadingSearch = false;
            });
        })
        .catch((err) => {
          console.log(err);
          this.loadingSearch = true;
        });
    },
    saveLicense() {
      let saveData = {
        resourceType: "Basic",
        meta: {
          profile: [
            this.isNewLicense
              ? "http://ihris.org/fhir/StructureDefinition/ihris-basic-license"
              : this.isRenewal
              ? "http://ihris.org/fhir/StructureDefinition/ihris-basic-license-renewal"
              : this.isGoodStanding
              ? "http://ihris.org/fhir/StructureDefinition/ihris-basic-good-standing"
              : "",
          ],
        },
        extension: [
          {
            url: "http://ihris.org/fhir/StructureDefinition/ihris-practitioner-reference",
            valueReference: {
              reference: "Practitioner/" + this.$route.params.id,
            },
          },
          {
            url: this.isNewLicense
              ? "http://ihris.org/fhir/StructureDefinition/ihris-license"
              : this.isRenewal
              ? "http://ihris.org/fhir/StructureDefinition/ihris-license-renewal"
              : this.isGoodStanding
              ? "http://ihris.org/fhir/StructureDefinition/ihris-good-standing"
              : "",
            extension: [],
          },
        ],
      };

      if (this.isNewLicense || this.isRenewal) {
        let professions = [];
        let tempProfession = "";
        this.licenseData.licenseProfessions?.forEach((element) => {
          professions.push({
            profession:
              (element && element.professionalTypes
                ? element.professionalTypes.name
                : "") +
                "--" +
                (element && element.prefix != null ? element.prefix : "") +
                "   " +
                (element.professionalTypes
                  ? element.professionalTypes.amharicProfessionalType
                  : "") +
                "," ??
              "" ??
              "",
          });
        });

        professions.forEach((element) => {
          tempProfession += element.profession ? element.profession : "";
        });
        saveData.extension[1].extension = [
          {
            url: "institution",
            valueString: "",
          },
          {
            url: "licenseNumber",
            valueString: this.searchLicense,
          },
          {
            url: "certifiedDate",
            valueDate: this.licenseData
              ? this.licenseData.certifiedDate.slice(0, 10)
              : "",
          },
          {
            url: "expirationDate",
            valueDate: this.licenseData
              ? this.licenseData.licenseExpirationDate.slice(0, 10)
              : "",
          },
          {
            url: "professionName",
            valueString: this.licenseData ? tempProfession : "",
          },
        ];
      }

      if (this.isGoodStanding) {
        let professions = [];
        let tempProfession = "";
        this.licenseData.GSprofessionals?.forEach((element) => {
          professions.push({
            profession:
              (element && element.professionalTypes
                ? element.professionalTypes.name
                : "") +
                "--" +
                (element && element.prefix != null ? element.prefix : "") +
                "   " +
                (element.professionalTypes
                  ? element.professionalTypes.amharicProfessionalType
                  : "") +
                "," ??
              "" ??
              "",
          });
        });
        professions.forEach((element) => {
          tempProfession += element.profession ? element.profession : "";
        });
        saveData.extension[1].extension = [
          {
            url: "issuedTo",
            valueString: this.licenseData
              ? this.licenseData.whomGoodStandingFor
              : "",
          },
          {
            url: "issuer",
            valueString: this.licenseData ? this.licenseData.whoIssued : "",
          },
          {
            url: "licenseNumber",
            valueString: this.searchLicense,
          },
          {
            url: "certifiedDate",
            valueDate: this.licenseData
              ? this.licenseData.certifiedDate.slice(0, 10)
              : "",
          },

          {
            url: "professionName",
            valueString: this.licenseData ? tempProfession : "",
          },
        ];
      }
      let save=false;
      let licenseProfile =
        "http://ihris.org/fhir/StructureDefinition/ihris-basic-license";
      let renewalProfile =
        "http://ihris.org/fhir/StructureDefinition/ihris-basic-license-renewal";
      let gsProfile =
        "http://ihris.org/fhir/StructureDefinition/ihris-basic-good-standing";
      fetch(
        "/fhir/Basic?_profile" +
          licenseProfile +
          "," +
          renewalProfile +
          "," +
          gsProfile +
          ",&practitioner=" +
          this.$route.params.id
      ).then((response) => {
        response.json().then((data) => {
         
          if (data.total > 0) {
            data.entry.forEach((extension) => {
              if (
                extension.resource.extension &&
                extension.resource.extension[1] &&
                extension.resource.extension[1].extension
              ) {
                let found = extension.resource.extension[1].extension.find(
                  (ext) => ext.url == "licenseNumber"
                )
                  ? extension.resource.extension[1].extension.find(
                      (ext) => ext.url == "licenseNumber"
                    ).valueString
                  : "";
                if (found == this.searchLicense.toUpperCase()) {
                  this.message =
                    "There is an already existing license with this license number";
                  this.snackbar = true;
                 save=false;
                 return true;
                } else{
                  save=true; 
                  return true;
                }
              }
            });
            
            if(save==true){
                axios
                    .post(`/fhir/Basic/`, saveData)
                    .then(() => {
                      this.setupData();
                      this.dialog=false;
                    })
                    .catch((err) => {
                      console.log("error", err);
                    });
            }
              
          }
        });
      });
    },
    setupLink(link, item) {
      return link.replace("ITEMID", item.id).replace("FHIRID", this.linkId);
    },

    convertGE(val) {
      if (!val) return val;
      const [year, month, day] = val.split("-").map(Number);

      let etDate = ethiopic.ge(year, month || 1, day || 1);
      return etDate.year.toString().padStart(4, "0");
    },
  },
};
</script>
<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
